<div class="no-data-container">
    <img src="/assets/no-data-img.svg" alt="no-data-img" class="no-data-img">
    <h1 class="no-data-title">
        {{heading ? heading : 'No Data Found'}}
    </h1>
    <div class="no-data-description">
        {{description ? description : "No records found"}}
    </div>
</div>